import { onBeforeUnmount, ref } from 'vue'

export function isInvalidPublicCapability(error) {
  const status = error?.response?.status
  const key = error?.response?.data?.key || ''
  return (
    [401, 403, 404, 410].includes(status) ||
    /(?:invalid|expired|revoked|used).*?(?:token|jwt)/i.test(key)
  )
}

export default function usePublicContext() {
  const publicState = ref('loading')
  let version = 0
  let disposed = false
  let currentToken = ''
  onBeforeUnmount(() => {
    disposed = true
    version++
  })

  async function loadPublicContext(token, request, apply) {
    const current = ++version
    currentToken = token
    publicState.value = 'loading'
    if (typeof token !== 'string' || !token.trim()) {
      publicState.value = 'invalid'
      return
    }
    try {
      const response = await request()
      if (disposed || current !== version) return
      if (response?.token_validity === false && !response.upload_completed) {
        publicState.value = 'invalid'
        return
      }
      apply(response)
      publicState.value = 'ready'
    } catch (error) {
      if (disposed || current !== version) return
      publicState.value = isInvalidPublicCapability(error) ? 'invalid' : 'failed'
    }
  }

  const isPublicContextCurrent = (token) => !disposed && token === currentToken
  return { publicState, loadPublicContext, isPublicContextCurrent }
}
